// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c2965dd4","186":"1599a6f9","272":"813959b2","372":"94369009","377":"9b2f343f","738":"b3b444d7","841":"f6f6cba3","851":"8dee856d","856":"6294b293"}[chunkId] + ".chunk.js";
};